/**** session clear when user enter from menue start  ****/
setTimeout(function(){  
    jQuery(".customh-nav-item").click(function() {     
        localStorage.clear();
      });

      jQuery(".customh-dropdown").click(function() {     
        localStorage.clear();
      });
}, 1600);  

